import { render, staticRenderFns } from "./YogoHeader.vue?vue&type=template&id=70cdbf64&"
import script from "./YogoHeader.vue?vue&type=script&lang=js&"
export * from "./YogoHeader.vue?vue&type=script&lang=js&"
import style0 from "./YogoHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports